import React, { Component } from 'react';
import Article from './Article';

class Contact extends Component {
  render() {
    return (
      <Article>
        <div id="article-main" className="flex-overflow-item">
          <h2>Want to hire me?</h2>
          <p>
            Are you looking for a demonstrated problem solver, great communicator, and creative solutions driver to help
            with your team or next project? <a href="mailto:weik55@gmail.com">Let's talk.</a>
          </p>
          <p>
            If you are a positive, growing team looking to work with passionate,
            self-motivated individuals on your next technical project, perhaps I can be the missing puzzle piece
            that pushes your project to success. I am a full stack developer, primarily coding in Java, C#,
            and Javascript, and I am currently available for hire. If this sounds good to you, send me an email at <a href="mailto:weik55@gmail.com">weik55@gmail.com</a>.
          </p>
        </div>
      </Article>
    );
  }
}

export default Contact;


// WEBPACK FOOTER //
// ./src/Contact.js